const MAX_STAMP_IMAGE_SIDE = 256;

const stripImageDataUrlPrefix = (value: string): string => {
  const [, base64 = value] = value.split(',');

  return base64;
};

const getStampImageSize = (
  width: number,
  height: number
): { width: number, height: number } => {
  const scale = Math.min(1, MAX_STAMP_IMAGE_SIDE / Math.max(width, height));

  return {
    width: Math.max(1, Math.round(width * scale)),
    height: Math.max(1, Math.round(height * scale)),
  };
};

const loadImage = (src: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });

export const getImageBase64Src = (value?: string | null): string => {
  if (!value) return '';
  if (value.startsWith('data:')) return value;

  return `data:image/png;base64,${value}`;
};

export const compressOrganisationStampBase64 = async (value: string): Promise<string> => {
  if (!value) return '';

  try {
    const image = await loadImage(getImageBase64Src(value));
    const { width, height } = getStampImageSize(image.naturalWidth, image.naturalHeight);
    const isOriginalPngDataUrl = value.startsWith('data:image/png');
    const isAlreadySmall = width === image.naturalWidth && height === image.naturalHeight;

    if (isAlreadySmall && !value.startsWith('data:')) return value;
    if (isAlreadySmall && isOriginalPngDataUrl) return stripImageDataUrlPrefix(value);

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    if (!context) return stripImageDataUrlPrefix(value);

    canvas.width = width;
    canvas.height = height;
    context.drawImage(image, 0, 0, width, height);

    return canvas.toDataURL('image/png').split(',')[1];
  } catch {
    return stripImageDataUrlPrefix(value);
  }
};

export const readCompressedOrganisationStampFile = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onerror = reject;
    reader.onload = () => {
      compressOrganisationStampBase64(String(reader.result ?? ''))
        .then(resolve)
        .catch(reject);
    };

    reader.readAsDataURL(file);
  });
